// src/components/AddCompanyForm/ActionBar.jsx
import React from "react";
import { Box, Button } from "@mui/material";

export default function ActionBar({ onClose, isFetching, disabled, children }) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        mx: -2,
        px: 2,
        py: 1,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        justifyContent: "flex-end",
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Box sx={{ mr: "auto", fontSize: 13, color: "text.secondary" }}>{children}</Box>
      <Button variant="outlined" onClick={onClose} disabled={isFetching}>
        Cancelar
      </Button>
      <Button type="submit" variant="contained" disabled={isFetching || disabled}>
        {isFetching ? "Salvando..." : "Salvar"}
      </Button>
    </Box>
  );
}
